import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLinkIcon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
import { Card } from '../components/Card';
import { TrustScore } from '../components/TrustScore';
import { cryptocurrencies } from '../data/mockData';
export function CryptocurrenciesPage() {
  return <div className="min-h-screen bg-slate-50" data-id="element-79">
      <div className="bg-gradient-to-br from-slate-900 to-blue-900 text-white py-12" data-id="element-80">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-81">
          <h1 className="text-4xl font-bold mb-3" data-id="element-82">Top 10 Cryptocurrencies</h1>
          <p className="text-slate-300 text-lg" data-id="element-83">
            Comprehensive reviews and trust scores for the leading
            cryptocurrencies
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-84">
        <div className="space-y-4" data-id="element-85">
          {cryptocurrencies.map(crypto => <Link key={crypto.id} to={`/cryptocurrency/${crypto.id}`} data-id="element-86">
              <Card className="p-6" hover data-id="element-87">
                <div className="flex flex-col lg:flex-row lg:items-center gap-6" data-id="element-88">
                  {/* Rank & Name */}
                  <div className="flex items-center gap-4 lg:w-64" data-id="element-89">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0" data-id="element-90">
                      {crypto.rank}
                    </div>
                    <div data-id="element-91">
                      <h3 className="font-semibold text-xl mb-1" data-id="element-92">
                        {crypto.name}
                      </h3>
                      <span className="text-slate-500 font-medium" data-id="element-93">
                        {crypto.symbol}
                      </span>
                    </div>
                  </div>

                  {/* Trust Score */}
                  <div className="lg:w-32" data-id="element-94">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-95">
                      Trust Score
                    </div>
                    <TrustScore score={crypto.trustScore} data-id="element-96" />
                  </div>

                  {/* Price */}
                  <div className="lg:w-40" data-id="element-97">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-98">Price</div>
                    <div className="font-semibold text-lg" data-id="element-99">
                      ${crypto.price.toLocaleString()}
                    </div>
                  </div>

                  {/* 24h Change */}
                  <div className="lg:w-32" data-id="element-100">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-101">
                      24h Change
                    </div>
                    <div className={`flex items-center gap-1 font-semibold ${crypto.change24h >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-102">
                      {crypto.change24h >= 0 ? <TrendingUpIcon size={16} data-id="element-103" /> : <TrendingDownIcon size={16} data-id="element-104" />}
                      <span data-id="element-105">
                        {crypto.change24h >= 0 ? '+' : ''}
                        {crypto.change24h.toFixed(2)}%
                      </span>
                    </div>
                  </div>

                  {/* Market Cap */}
                  <div className="lg:w-40" data-id="element-106">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-107">
                      Market Cap
                    </div>
                    <div className="font-medium" data-id="element-108">
                      ${(crypto.marketCap / 1000000000).toFixed(1)}B
                    </div>
                  </div>

                  {/* Volume */}
                  <div className="lg:w-40" data-id="element-109">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-110">
                      24h Volume
                    </div>
                    <div className="font-medium" data-id="element-111">
                      ${(crypto.volume24h / 1000000000).toFixed(1)}B
                    </div>
                  </div>

                  {/* Reviews */}
                  <div className="lg:w-32 lg:ml-auto" data-id="element-112">
                    <div className="text-xs text-slate-500 mb-1" data-id="element-113">Reviews</div>
                    <div className="font-medium" data-id="element-114">
                      {crypto.reviews.length} reviews
                    </div>
                  </div>
                </div>
              </Card>
            </Link>)}
        </div>
      </div>
    </div>;
}